// Reglas de contraseña (deben coincidir con el backend).
export const getPasswordChecks = (pw = "") => ({
  length: pw.length >= 8,
  upper: /[A-Z]/.test(pw),
  lower: /[a-z]/.test(pw),
  number: /[0-9]/.test(pw),
  symbol: /[^A-Za-z0-9]/.test(pw),
});

// Validación estándar (4 reglas) — usada en flujos donde el usuario ya está
// autenticado (cambio inline en "Mi perfil", edición de usuario).
export const isPasswordValid = (pw = "") => {
  const c = getPasswordChecks(pw);
  return c.length && c.upper && c.lower && c.number;
};

// Validación FUERTE (5 reglas, incluye símbolo) — usada al fijar la contraseña
// desde invitación o restablecimiento.
export const isStrongPasswordValid = (pw = "") => {
  const c = getPasswordChecks(pw);
  return c.length && c.upper && c.lower && c.number && c.symbol;
};

// Nivel de seguridad: 1=Débil, 2=Media, 3=Fuerte.
export const getPasswordStrength = (pw = "") => {
  if (!pw) return { level: 0, label: "", color: "#e5e7eb" };

  const c = getPasswordChecks(pw);
  let score = 0;
  ["length", "upper", "lower", "number", "symbol"].forEach((k) => {
    if (c[k]) score++;
  });
  if (pw.length >= 12) score++; // longitud extra

  if (score <= 2) return { level: 1, label: "Débil", color: "#ef4444" };
  if (score <= 4) return { level: 2, label: "Media", color: "#f59e0b" };
  return { level: 3, label: "Fuerte", color: "#16a34a" };
};

export const PASSWORD_ERROR =
  "La contraseña debe tener al menos 8 caracteres e incluir mayúscula, minúscula y número.";

export const STRONG_PASSWORD_ERROR =
  "La contraseña debe tener al menos 8 caracteres e incluir mayúscula, minúscula, número y símbolo.";
